<style scoped>  

  @media only screen and (min-width: 991px) {
    .content {
      height: 330px;
    }
    .compensation {    
      height: calc(100vh - 210px);
      transition: 0.3s linear;
    }
  }

</style>

<template>

  <div :id="_uid" class="ui modal" :class="modalSelector">

    <div class="ui header">
      Baixar Título a Pagar
    </div>

    <div class="content" :class="{ 'scrolling compensation': compensation }">

      <div class="ui form" :class="{ loading }">
        <div class="fields">
          <div class="four wide field">
            <label class="form-label">Título</label>
            <input :value="payable.id" readonly="readonly">
          </div>
          <div class="twelve wide field">
            <label class="form-label">Fornecedor</label>
            <input :value="payable.supplier.shortName" readonly="readonly">
          </div>
        </div>
        <div class="fields">
          <div class="four wide field">
            <label class="form-label">Vencimento</label>
            <input :value="$formatDate(payable.realDueDate)" readonly="readonly">
          </div>
          <div class="four wide field">
            <label class="form-label">Valor Título</label>
            <input :value="$formatCurrency(payable.value)" readonly="readonly">
          </div>
          <div class="four wide field">
            <label class="form-label">Saldo</label>
            <input :value="$formatCurrency(payable.balance)" readonly="readonly">
          </div>
          <div class="four wide field">
            <label class="form-label">Valor Baixado</label>
            <input :value="$formatCurrency(payable.value - payable.balance)" readonly="readonly">
          </div>          
        </div>  
        <div class="fields">
          <div class="four wide field">
            <label class="form-label">Data <span class="red text">*</span></label>
            <date-picker ref="datePicker" :autoInit="false" @onChange="onChangeDate" />
          </div>
          <div class="four wide field">
            <label class="form-label">Referência <span class="red text">*</span></label>
            <date-picker ref="refDatePicker" :autoInit="false" @onChange="onChangeRefDate" />
          </div>
          <div class="four wide field">
            <label class="form-label">Valor da Baixa <span v-if="!compensation" class="red text">*</span></label>
            <input class="money" :value="settleValue" @blur="settleValue = $event.target.value">
          </div>
          <div v-if="compensation" class="four wide field">
            <label class="form-label">Créditos</label>
            <input :value="$formatCurrency(creditsValue)" readonly="readonly">
          </div>
          <div v-if="compensation" class="four wide field">
            <label class="form-label">Total da Baixa <span class="red text">*</span></label>
            <input :value="$formatCurrency(totalValue)" readonly="readonly">
          </div>
        </div> 
        <div v-if="!compensation && credits.length && !disableCompensation" class="fields m-t-30">
          <div class="sixteen wide field">
            <a class="clickable" @click="compensation = true">
              {{ credits.length == 1 ? '1 crédito em aberto' : credits.length + ' créditos em aberto' }}
            </a>
          </div>
        </div>   
      </div>

      <div v-if="compensation" class="m-t-30">
        <div class="ui basic segment no-padding no-margin">
          <h4 class="ui dividing header">Créditos</h4>
          <table class="ui celled selectable tablet stackable table">
            <thead v-if="$isDesktop">
              <tr>
                <th>Número</th>
                <th>Emissão</th>
                <th>Vencimento</th>
                <th>Valor</th>
                <th>Saldo</th>
              </tr>  
            </thead>
            <tbody>
              <tr v-for="(credit, index) in credits" @click="onSelectCredit(index)">
                <td>
                  <strong class="mobile-only">Número: </strong>
                  <i class="circle blue icon m-r-15" :class="{ check: credit.selected, outline: !credit.selected }"></i>
                  {{ credit.id }}
                </td>
                <td>
                  <strong class="mobile-only">Emissão: </strong>
                  {{ $formatDate(credit.date) }}
                </td>   
                <td>
                  <strong class="mobile-only">Vencimento: </strong>
                  {{ $formatDate(credit.dueDate) }}
                </td>
                <td>
                  <strong class="mobile-only">Valor: </strong>
                  R$ {{ $formatCurrency(credit.value) }}
                </td>   
                <td>
                  <strong class="mobile-only">Saldo: </strong> 
                  R$ {{ $formatCurrency(credit.balance) }}
                </td>                   
              </tr>                
            </tbody>
          </table>
        </div>
      </div>

    </div>

    <div class="actions">
      <button class="ui cancel basic button">
        <i class="times icon"></i> Cancelar
      </button>            
      <button class="ui blue button" @click="onConfirm()">
        <i class="checkmark icon"></i> Confirmar
      </button>
    </div>

  </div>

</template>

<script>

  import PayableService from "@/services/payable-service"
  import modalDialog from "@/mixins/modal-dialog"  
  import DatePicker from "@/components/date-picker"
  import { moment, Input } from "@/utils"

  export default {
    
    name: "SettleValueModal",

    mixins: [modalDialog],

    data() {
      return {
        payable: { supplier: {} },
        credits: [],
        value: null,
        date: null,
        refDate: null,
        compensation: false,
        service: new PayableService(),
      }
    },

    props: {
      autoFill: { type: Boolean, default: false },
      disableCompensation: { type: Boolean, default: false },
    },

    components: {
      DatePicker,
    },

    mounted() {
      Input.maskCurrency()
    },

    computed: {

      settleValue: {
        get() {
          return Input.currencyToString(this.value)
        },
        set(value) {
          this.value = Input.stringToCurrency(value)
        },
      },

      creditsValue() {

        let value = 0

        for (const credit of this.credits) {
          if (credit.selected)
            value += credit.balance
        }

        return value
      },

      totalValue() {
        return (this.value + this.creditsValue)
      },
    },

    methods: {

      load(payable) {

        this.loading = true
        this.compensation = false
        this.value = null
        this.date = new Date()
        this.refDate = this.date
        this.payable = this.$cloneObject(payable)        

        if (this.autoFill)
          this.value = this.payable.balance
        
        this.show()
      },

      onVisible() {

        this.$refs.datePicker.initCalendar({ force: true })
        this.$refs.refDatePicker.initCalendar({ force: true })

        if (this.autoFill) {
          this.$refs.datePicker.setDate(this.date)
          this.$refs.refDatePicker.setDate(this.refDate)
        } else {
          this.$refs.datePicker.clearDate()
          this.$refs.refDatePicker.clearDate()
        }  

        if (this.payable.balance && this.payable.type != "credit") {
          this.loadCredits()
        } else {
          this.loading = false           
        }        
      },

      onChangeDate(date) {

        this.date = date || null

        if (!this.loading)
          this.$refs.refDatePicker.setDate(this.date)
      },

      onChangeRefDate(date) {
        this.refDate = date || null
      },

      async loadCredits() {

        try {

          this.credits = await this.service.getCredits(this.payable.id)
          
        } catch (error) {
          
          this.$errorHandler(error)
        
        } finally {

          this.loading = false
        }
      },

      onSelectCredit(index) {

        let credits = this.credits.slice()

        credits[index].selected = !credits[index].selected

        this.credits = credits.slice()

        let value = (this.payable.balance - this.creditsValue)

        if (value < 0)
          value = 0
        
        this.value = value
      },

      onConfirm() {

        if (!this.validConfirmation())
          return

        this.emit("onConfirm", { 
          payable: this.payable,
          value: this.value, 
          date: this.date,
          refDate: this.refDate,
          credits: this.getSelectedCredits(),
        })
      },

      validConfirmation() {

        let isOk = true
        let msg = ""

        if (!this.totalValue) {
          msg = "Informe o valor a ser baixado"
        } else if (!this.date) {
          msg = "Informe a data da baixa"
        } else if (!this.refDate) {
          msg = "Informe a data de referência baixa"  
        }  

        if (msg) {
          isOk = false
          this.$msg.warn(msg)
        }

        return isOk  
      },

      getSelectedCredits() {

        let credits = []

        for (const credit of this.credits) {
          if (credit.selected)
            credits.push(credit)
        }

        return credits
      },
    },
  }

</script>